import remoteRepresentativeRandstadTheme from '../themes/Randstad/remote-representative';
import { getAppConsts } from './AppConstantsProvider';
import Colors from '../interfaces/Colors';
import Typography from '../interfaces/Typography';
import Framing from '../interfaces/Framing';
import Theme from '../interfaces/Theme';
import baseTheme from '../themes/Base';
import swipejobsTheme from "../themes/Swipejobs/Swipejobs";
import branchDesktopSwipejobsTheme from '../themes/Swipejobs/branch-desktop';
import customerDesktopSwipejobsTheme from '../themes/Swipejobs/customer-desktop';
import jobstackTheme from '../themes/Jobstack/Jobstack';
import branchDesktopJobstackTheme from '../themes/Jobstack/branch-desktop';
import customerDesktopJobstackTheme from '../themes/Jobstack/customer-desktop';
import randstadTheme from '../themes/Randstad/Randstad';
import branchDesktopRandstadTheme from '../themes/Randstad/branch-desktop';
import customerDesktopRandstadTheme from '../themes/Randstad/customer-desktop';
import kellyTheme from '../themes/Kelly/Kelly';
import branchDesktopKellyTheme from '../themes/Kelly/branch-desktop';
import customerDesktopKellyTheme from '../themes/Kelly/customer-desktop';
import employBridgeTheme from '../themes/EmployBridge/EmployBridge';
import branchDesktopEmployBridgeTheme from '../themes/EmployBridge/branch-desktop';
import customerDesktopEmployBridgeTheme from '../themes/EmployBridge/customer-desktop';

export class ThemeProvider {

    private partner: string = null;
    private appType: string = null;
    private theme: Theme = null;

    getColors(): Colors {
        this.resolveTheme();
        return this.theme.colors;
    };

    getTypography(): Typography {
        this.resolveTheme();
        return this.theme.typography;
    };

    getFraming(): Framing {
        this.resolveTheme();
        return this.theme.framing;
    };

    /**
     * lazily swaps out referenced theme object based upon angularjs loading status
     */
    private resolveTheme() {

        if (this.partner && this.appType) {
            // already resolved
            return;
        }

        const appConsts = getAppConsts();

        if (!this.partner && appConsts) {
            this.partner = appConsts.PARTNER_ID;
        }

        if (!this.appType && appConsts) {
            this.appType = appConsts.APP_TYPE;
        }

        if (this.partner === 'sj') {
            if (this.appType === 'desktop') {
                this.theme = branchDesktopSwipejobsTheme;
            } else if (this.appType === 'customer') {
                this.theme = customerDesktopSwipejobsTheme;
            } else {
                this.theme = swipejobsTheme;
            }
        } else if (this.partner === 'js') {
            if (this.appType === 'desktop') {
                this.theme = branchDesktopJobstackTheme;
            } else if (this.appType === 'customer') {
                this.theme = customerDesktopJobstackTheme
            } else {
                this.theme = jobstackTheme;
            }
        } else if (this.partner === 'rs') {
            if (this.appType === 'desktop') {
                this.theme = branchDesktopRandstadTheme;
            } else if (this.appType === 'customer') {
                this.theme = customerDesktopRandstadTheme
            } else if (this.appType === 'remote-representative') {
                this.theme = remoteRepresentativeRandstadTheme;
            } else {
                this.theme = randstadTheme;
            }
        } else if (this.partner === 'ks') {
            if (this.appType === 'desktop') {
                this.theme = branchDesktopKellyTheme;
            } else if (this.appType === 'customer') {
                this.theme = customerDesktopKellyTheme
            } else {
                this.theme = kellyTheme;
            }
        } else if (this.partner === 'eb') {
            if (this.appType === 'desktop') {
                this.theme = branchDesktopEmployBridgeTheme;
            } else if (this.appType === 'customer') {
                this.theme = customerDesktopEmployBridgeTheme
            } else {
                this.theme = employBridgeTheme;
            }
        } else {
            this.theme = baseTheme;
        }
    };
}

export const themeProvider = new ThemeProvider();



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/services/ThemeProvider.ts